<script>
import { Bar } from "vue-chartjs";

export default {
  extends: Bar,
  props: ["title", "data"],
  data() {
    return {};
  },
  mounted() {
    this.load();
  },
  watch: {
    data() {
      this.load();
    },
  },
  methods: {
    load() {
      this.renderChart(
        {
          labels: [
            "January",
            "February",
            "March",
            "April",
            "May",
            "June",
            "July",
            "August",
            "September",
            "October",
            "November",
            "December",
          ],
          datasets: [
            {
              label: this.$props.title,
              backgroundColor: "#5E83BA",
              data: this.$props.data,
              datalabels: {
                display: false,
              },
            },
          ],
        },
        { responsive: true, maintainAspectRatio: false }
      );
    },
  },
};
</script>
